import { faHome, faStore, faMegaphone, faTag, faGear, faUser } from "@fortawesome/pro-light-svg-icons"
import {
    MERCHANT_ADMIN_ROUTE,
    MERCHANT_ADMIN_SETTINGS_ROUTE,
    MERCHANT_NEWS_ROUTE,
    MERCHANT_ADMIN_USERS_ROUTE,
    MERCHANT_ADMIN_SHOPS_ROUTE,
    MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE,
    MERCHANT_ADMIN_PRODUCTS_GROUP_ROUTE,
    MERCHANT_ADMIN_PRICE_LISTS_ROUTE,
    MERCHANT_ADMIN_SURVEYS,
    MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE,
    MERCHANT_ADMIN_COMMUNICATION_ROUTE,
    MERCHANT_ADMIN_SHOPS_LIST_ROUTE,
    MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE,
    MERCHANT_ADMIN_ROUTE_DEVICES,
    MERCHANT_ADMIN_MERCHANT_ACCOUNT_ROUTE,
    MERCHANT_ADMIN_ACCOUNT_ROUTE,
    MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE,
    MERCHANT_ADMIN_OFFERS_ROUTE,
    MERCHANT_ADMIN_PRODUCTS_ROUTE,
    MERCHANT_ADMIN_SETTINGS_ID_CARDS_ROUTE,
    MERCHANT_ADMIN_SHOPS_CUSTOMER_ACCESS_ROUTE,
    MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE,
    VIEWS_MERCHANT_CONFERENCE_ROUTE,
    MERCHANT_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE,
    MERCHANT_ADMIN_EXTRA_SERVICES_ROUTE,
    MESSAGES_ROUTE,
} from "../../../../constants/routes"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../environment/envTypes"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { UserType } from "../../../login/loginTypes"
import { MatchActualUserType } from "../../../accessControl/MatchActualUserType"

type Props = Readonly<{}>

export function MerchantAdminNavItems({}: Props) {
    return (
        <>
            <LocalizedStrict id="merchant-nav-item-home">
                <NavMenuItem icon={faHome} dest={MERCHANT_ADMIN_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>

            <LocalizedStrict id="merchant-nav-item-communication-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper
                    icon={faMegaphone}
                    dest={MERCHANT_ADMIN_COMMUNICATION_ROUTE}
                    title="Communication"
                >
                    <LocalizedStrict id="merchant-nav-item-surveys">
                        <NavMenuSubItem route={MERCHANT_ADMIN_SURVEYS}>Surveys</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-messaging">
                        <NavMenuSubItem route={MESSAGES_ROUTE}>Push messages</NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        <LocalizedStrict id="merchant-nav-item-news">
                            <NavMenuSubItem route={MERCHANT_NEWS_ROUTE}>Merchant news</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-nav-item-group-products" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faTag} dest={MERCHANT_ADMIN_PRODUCTS_ROUTE} title="Products">
                    <LocalizedStrict id="merchant-nav-item-products">
                        <NavMenuSubItem route={MERCHANT_ADMIN_PRODUCTS_LIST_ROUTE}>Products</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-product-groups">
                        <NavMenuSubItem route={MERCHANT_ADMIN_PRODUCTS_GROUP_ROUTE}>Product group</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-extra-services">
                        <NavMenuSubItem route={MERCHANT_ADMIN_EXTRA_SERVICES_ROUTE}>Extra services</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-price-lists">
                        <NavMenuSubItem route={MERCHANT_ADMIN_PRICE_LISTS_ROUTE}>Price list</NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment environments={[EnvironmentType.Local, EnvironmentType.Test]}>
                        <LocalizedStrict id="merchant-nav-item-offers">
                            <NavMenuSubItem route={MERCHANT_ADMIN_OFFERS_ROUTE}>Offers</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-nav-item-group-shops" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faStore} dest={MERCHANT_ADMIN_SHOPS_ROUTE} title="Shops">
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        <LocalizedStrict id="merchant-nav-item-shops">
                            <NavMenuSubItem route={MERCHANT_ADMIN_SHOPS_LIST_ROUTE}>Shops</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        <LocalizedStrict id="merchant-nav-item-payment-links">
                            <NavMenuSubItem route={MERCHANT_ADMIN_PAYMENT_LINKS_ROUTE}>Payment links</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                    <LocalizedStrict id="merchant-nav-item-devices">
                        <NavMenuSubItem route={MERCHANT_ADMIN_ROUTE_DEVICES}>Devices</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-customer-access">
                        <NavMenuSubItem route={MERCHANT_ADMIN_SHOPS_CUSTOMER_ACCESS_ROUTE}>
                            Customer Access
                        </NavMenuSubItem>
                    </LocalizedStrict>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-nav-item-settings-page-header" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faGear} dest={MERCHANT_ADMIN_SETTINGS_ROUTE} title="Settings">
                    <LocalizedStrict id="merchant-nav-item-vat-codes">
                        <NavMenuSubItem route={MERCHANT_ADMIN_SETTINGS_VAT_CODES_ROUTE}>VAT Codes</NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        <LocalizedStrict id="merchant-nav-item-delivery-locations">
                            <NavMenuSubItem route={MERCHANT_ADMIN_SETTINGS_DELIVERY_LOCATIONS_ROUTE}>
                                Delivery locations
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        <LocalizedStrict id="merchant-nav-item-sales-accounts">
                            <NavMenuSubItem route={MERCHANT_ADMIN_SETTINGS_SALES_ACCOUNTS_ROUTE}>
                                Sales accounts
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                    <LocalizedStrict id="merchant-nav-item-id-cards">
                        <NavMenuSubItem route={MERCHANT_ADMIN_SETTINGS_ID_CARDS_ROUTE}>ID cards</NavMenuSubItem>
                    </LocalizedStrict>
                    <LocalizedStrict id="merchant-nav-item-custom-jobs">
                        <NavMenuSubItem route={MERCHANT_ADMIN_SETTINGS_CUSTOM_JOBS_ROUTE}>Custom jobs</NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchActualUserType userTypes={[UserType.SUPPORT]}>
                        <LocalizedStrict id="merchant-nav-item-live-dashboard">
                            <NavMenuSubItem route={VIEWS_MERCHANT_CONFERENCE_ROUTE}>Live dashboard</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchActualUserType>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
            <LocalizedStrict id="merchant-nav-item-group-account" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faUser} dest={MERCHANT_ADMIN_ACCOUNT_ROUTE} title="Account">
                    <LocalizedStrict id="merchant-nav-item-users">
                        <NavMenuSubItem route={MERCHANT_ADMIN_USERS_ROUTE}>Administrators</NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
                    >
                        <LocalizedStrict id="merchant-nav-item-merchant-account">
                            <NavMenuSubItem route={MERCHANT_ADMIN_MERCHANT_ACCOUNT_ROUTE}>
                                Merchant account
                            </NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
        </>
    )
}
